import * as Yup from 'yup';

export const inventeringFormSchema = Yup.object().shape({
  titel: Yup.string()
    .required('Titel är obligatorisk')
    .max(255, 'Titelns längd får vara max 255 tecken')
    .test('Not empty', 'Titel är obligatorisk', (value) => (value ? value.trim().length > 0 : true)),
  syfte: Yup.string()
    .required('Syfte är obligatorisk')
    .test('Not empty', 'Syfte är obligatorisk', (value) => (value ? value.trim().length > 0 : true)),
  start_ar: Yup.number()
    .typeError('Årtal fr.o.m måste anges med siffror')
    .test('length', 'Årtal fr.o.m måste anges med 4 siffror', (value) =>
      value ? value.toString().replace(/ /g, '').length === 4 : true
    )
    .test('must start with 19 or 20', 'Årtal fr.o.m måste börja på 19 eller 20', (value) =>
      value ? value.toString().startsWith('19') || value.toString().startsWith('20') : true
    )
    .required('Inventeringsår fr.o.m är obligatorisk'),
  slut_ar: Yup.number()
    .nullable()
    .typeError('Årtal t.o.m måste anges med siffror')
    .transform((_, val) => (val ? Number(val) : null))
    .test('length', 'Årtal t.o.m måste anges med 4 siffror', (value) =>
      value ? value.toString().replace(/ /g, '').length === 4 : true
    )
    .min(Yup.ref('start_ar'), 'Slutår måste vara samma eller högre än startår')
    .test('must start with 19 or 20', 'Årtal t.o.m måste börja på 19 eller 20', (value) =>
      value ? value.toString().startsWith('19') || value.toString().startsWith('20') : true
    ),
  inventeringsomrade: Yup.mixed<any>()
    .required('Inventeringsområde är obligatorisk')
    .test('convertError', (value, context) =>
      value && value.convertError ? context.createError({ message: value.convertError }) : true
    )
});

export interface FormValues {
  titel: string;
  syfte: string;
  start_ar: string;
  slut_ar: string;
  inventeringsomrade: string;
}
